import React from 'react';
import { find, findIndex, cloneDeep, remove } from 'lodash';

import { PlayerCard } from '../../../cards';
import CollapsibleSection from '../../../CollapsibleSection';

import { acceptanceBucketTypes, acceptanceRankingValues } from '../../../../utils/eventConstants';
import styles from './bucket.scss';

const _ = { find, findIndex, cloneDeep, remove };

const Bucket = (props) => {
    const {
        buckets,
        bucket,
        type,
        teamList,
        playersTabState,
        playerActions,
        isCurrentMemberAdmin,
        currentDivision,
        showPlayerStatus,
        showPlayerPaymentStatus,
        showRatingNotLoggedIn,
        showHighSchoolName,
        event,
        auth,
        sendMessage,
        menuOnSelected,
        isPtsEvent,
        isWTARankType,
        playerPtsRanks,
        gridLayout,
        handleListOrderSelect,
        hideUtrLabel,
        'data-testid': dataTestId,
    } = props;
    const players = bucket ? bucket.players : teamList;
    const {
        sortAcceptanceType,
    } = playersTabState || {};
    const {
        countSpecialExempt,
        countByRanking,
    } = bucket || {};

    const playersAcceptedByWTA = players.filter(p => p.acceptanceType === acceptanceRankingValues.WTA);
    const playersAcceptedBySpecialExempt = playersAcceptedByWTA.filter(p => p.acceptanceListWildcardStateId === 4).length;
    const playerWithdrawnFromWTA = playersAcceptedByWTA.filter(p => p.isWithdrawn === true).length;
    const { sportTypeId } = event || {};

    const sectionTitle = bucket?.type ?? type;
    let infoText = null;
    if (isWTARankType && bucket?.type === acceptanceBucketTypes.MAIN) {
        const mainList = buckets.find(b => b.type === acceptanceBucketTypes.MAIN);
        const qualifyingList = buckets.find(b => b.type === acceptanceBucketTypes.QUALIFYING);
        infoText = (
            <div>
                <div className={'text-highlight1 text-dark'}>MAIN ACCEPTANCE:</div>
                <p>
                    A total of {mainList.count} players will be accepted into the main draw directly
                    based on either their WTA Rank or UTR Rating.
                </p>
                <p>
                    Of the {mainList.count} players accepted into the main draw, the top {mainList.countByRanking} spots
                    will be reserved for the highest WTA Ranked players and {mainList.count - mainList.countByRanking} spots to
                    the highest remaining players by UTR Rating.
                </p>
                {qualifyingList && (
                    <>
                        <div className={'text-highlight1 text-dark'}>QUALIFYING ACCEPTANCE:</div>
                        <p>
                            {qualifyingList.count} players will also be directly accepted into the qualifying draw.
                        </p>
                        <p>
                            Of the {qualifyingList.count} players accepted into the qualifying draw, the
                            top {qualifyingList.countByRanking} spots will be reserved for the highest WTA Ranked
                            players and {qualifyingList.count - qualifyingList.countByRanking} spots to the highest remaining players by UTR Rating.
                        </p>
                    </>
                )}
                <div className={'text-highlight1 text-dark'}>ALTERNATE LISTS:</div>
                <p>
                    All other registrants will be placed on two alternate list orders (1) WTA Rank Order and (2) UTR Rating Order.
                </p>
                <div className={'text-highlight1 text-dark'}>SPECIAL EXEMPTION:</div>
                <p>
                    Up to 2 special exempt spots may be held for players.
                </p>
            </div>
        );
    }
    if (countSpecialExempt > 0 && playersAcceptedBySpecialExempt < countSpecialExempt && playersAcceptedByWTA.length < countByRanking) {
        for (let k = 0; k < countSpecialExempt - playersAcceptedBySpecialExempt; k += 1) {
            const indexToUpdate = playersAcceptedByWTA.length + playerWithdrawnFromWTA + k;
            players.splice(indexToUpdate, 0, { specialExempt: true });
        }
    }
    const playerAcceptedByWTAIndex = players.findIndex(p => p.acceptanceType === acceptanceRankingValues.WTA);
    const playersAcceptedByUTRIndex = players.findIndex(p => p.acceptanceType === acceptanceRankingValues.UTR);

    return (
        <CollapsibleSection
            title={sectionTitle}
            infoText={infoText}
            sortAcceptanceType={sortAcceptanceType}
            showListSortButtons={isWTARankType && bucket?.type === acceptanceBucketTypes.ALTERNATE}
            handleListOrderSelect={handleListOrderSelect}
            className={'mb40'}
            data-testid={dataTestId}
        >
            <div className="d-flex text-small text-medium player-list-header">
                <div className="flex-grow">
                    <div className="row">
                        <div className={`d-none d-md-flex col-12 col-md-5`}>
                            <div className={`d-flex aic`}>
                                Name
                            </div>
                        </div>
                        <div className={`d-none d-md-flex col-md-7`}>
                            <div className="d-grid w-100" style={{ gridTemplateColumns: gridLayout.join(' ') }}>
                                {isWTARankType ? (
                                    <>
                                        <div className={``}>
                                            <div className={`d-flex aic`}>
                                                WTA Rank
                                            </div>
                                        </div>
                                        <div>
                                            <div className={`d-flex aic`}>
                                                WTA Order
                                            </div>
                                        </div>
                                        <div className={``}>
                                            <div className={`d-flex aic`}>
                                                Singles
                                            </div>
                                        </div>
                                        <div>
                                            <div className={`d-flex aic`}>
                                                UTR Order
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className={``}>
                                            <div className={`d-flex aic`}>
                                                Singles
                                            </div>
                                        </div>
                                        <div className={``}>
                                            <div className={`d-flex aic`}>
                                                Doubles
                                            </div>
                                        </div>
                                        {isPtsEvent && (
                                            <div className={``}>
                                                <div className={`d-flex aic`}>
                                                    PTT Rank
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                                {showPlayerStatus && (
                                    <div className={``}>
                                        <div className={`d-flex aic`}>
                                            Registration
                                        </div>
                                    </div>
                                )}
                                {showPlayerStatus && showPlayerPaymentStatus && (
                                    <div className={``}>
                                        <div className={`d-flex aic`}>
                                            Payment
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bookmark" />
            </div>
            {players && players.map((player, i) => {
                const playerDivision = _.find(player?.registeredDivisions,
                    { divisionId: playersTabState.divisionId });
                const actions = _.cloneDeep(playerActions);

                let acceptanceByText = '';
                let showAcceptanceByHeader = false;
                const isMainBucket = bucket?.type === acceptanceBucketTypes.MAIN;
                const showAcceptanceHeaderListTypes = [acceptanceBucketTypes.MAIN, acceptanceBucketTypes.QUALIFYING].includes(sectionTitle);
                if (playerAcceptedByWTAIndex !== -1 && i === playerAcceptedByWTAIndex && showAcceptanceHeaderListTypes) {
                    showAcceptanceByHeader = true;
                    acceptanceByText = `${isMainBucket ? 'Direct' : 'Qualifying'} Acceptance By WTA`;
                }
                if (playersAcceptedByUTRIndex !== -1 && i === playersAcceptedByUTRIndex && showAcceptanceHeaderListTypes) {
                    showAcceptanceByHeader = true;
                    acceptanceByText = `${isMainBucket ? 'Direct' : 'Qualifying'} Acceptance By UTR`;
                }

                if (isCurrentMemberAdmin && currentDivision.price === 'Free' && playerDivision?.paymentStatus === 'Paid' && playerDivision?.registrationStatus !== 'Withdrawn') {
                    const withdrawActionIndex = _.findIndex(playerActions, { value: 'withdraw' });
                    actions[withdrawActionIndex].label = 'Withdraw and Refund';
                }

                if (isCurrentMemberAdmin && (playersTabState.selectedStatus.value === 'withdrawn' || type === 'Withdrawn') && playerDivision?.paymentStatus !== 'Paid') {
                    _.remove(actions, { value: 'refund' });
                }

                const specialExemptCard = (index) => {
                    return (
                        <div data-test={`specialExemptCard`} data-testid={dataTestId && `${dataTestId}.special-exempt-card-${index}`} className={`d-flex flex-row ${styles.specialExemptCard}`}>
                            <div data-test={'index'} data-testid={dataTestId && `${dataTestId}.special-exempt-rank-${index}`} className={`${styles.rank}`}>{index}</div>
                            <label className="flex-grow-1 mb0">SPECIAL EXEMPT</label>
                        </div>
                    );
                };

                return (
                    <React.Fragment>
                        {showAcceptanceByHeader && (
                            <div className={`${styles.separator}`} data-test={`acceptanceHeader`} data-testid={dataTestId && `${dataTestId}.acceptance-header-${i}`}>
                                <div className={styles.line1} />
                                <h6 data-test={`acceptanceHeaderText-${i}`} data-testid={dataTestId && `${dataTestId}.acceptance-header-text-${i}`}>{acceptanceByText}</h6>
                                <div className={styles.line2} />
                            </div>
                        )}
                        {player.specialExempt ? (
                            specialExemptCard(i + 1)
                        ) : (
                            <PlayerCard
                                key={`player-${player.id}`}
                                player={player}
                                currentDivision={playersTabState.divisionId}
                                showPlayerStatus={showPlayerStatus}
                                showPlayerPaymentStatus={showPlayerPaymentStatus}
                                utrType={event.utrType.value}
                                menuOptions={actions}
                                menuOnSelected={(selected, e) => menuOnSelected(e, player.id, selected)}
                                addOptionsSpace={!!((playerActions && playerActions.length > 0))}
                                showDecimals={isCurrentMemberAdmin}
                                isCurrentMemberAdmin={isCurrentMemberAdmin}
                                showRatingNotLoggedIn={showRatingNotLoggedIn}
                                showHighSchoolName={showHighSchoolName}
                                auth={auth}
                                sendMessage={sendMessage}
                                hideRatings={false}
                                inactive={player.isWithdrawn}
                                optionSpaceContent={player.isWithdrawn ? 'WD' : null}
                                withdrawTag={player.withdrawTag}
                                rank={i + 1}
                                isWTARankType={isWTARankType}
                                ptsRank={isPtsEvent && (playerPtsRanks[player.id] || '--')}
                                hideUtrLabel={hideUtrLabel}
                                sportTypeId={sportTypeId}
                                data-testid={dataTestId && `${dataTestId}.player-${player.id}`}
                            />
                        )}
                    </React.Fragment>
                );
            })}
        </CollapsibleSection>
    );
};

export default Bucket;
